export const GYM_TOOLS_CATEGORIES = {
    spreadsheets: {
        key: 'spreadsheets',
        title: 'Spreadsheets',
        description:
            'Build a testing session for athletes to log ' +
            'or enter bulk data manually.',
        iconClass: 'mdi mdi-grid',
        segmentKey: 'SpreadsheetsListViewed',
        path: 'navigateToSpreadsheets',
        newTab: false
    }
};



// WEBPACK FOOTER //
// ./src/view/nav/constants.js